import { useTranslation } from 'react-i18next';
import { EmptyState } from '@/common/components/empty-state/EmptyState';

export const VisualizationNoItemsMatchFiltersState = () => {
  const { t } = useTranslation();

  return (
    <EmptyState
      variant="search"
      title={t(($) => $.views.visualization.emptyStates.noItemsMatchFilters.title)}
      description={t(($) => $.views.visualization.emptyStates.noItemsMatchFilters.description)}
    />
  );
};
